import { FC } from 'react';

import { Input } from 'view/component/Input/Input';
import { PrioridadeSelect } from 'view/component/Prioridade/PrioridadeSelect';
import { Formulario } from 'view/component/Formulario/Formulario';

import { Label } from 'view/component/Label/Label';
import { Botao } from 'view/component/Botao/Botao';
import { SituacaoSelect } from 'view/component/Situacao/SituacaoSelect';

import { H3 } from 'view/component/Tipografia/Texto';
import { DEVELOPMENT } from 'util/Dev';
import { ResponsavelTecnicoSelect } from 'view/component/ResponsavelTecnicoSelect/ResponsavelTecnicoSelect';
import { UnidadeSelect } from 'view/component/UnidadeSelect/UnidadeSelect';
import { ServidorField } from 'view/component/ServidorField/ServidorField';
import { SolicitacoesQueryParams } from 'service/api/solicitacao/ApiSolicitacoes';
import { RestricoesCamposBuscaSolicitacoesFormulario } from 'business/formulario/RestricoesBuscaSolicitacoesFormulario';
import { OperacaoFormularioBusca } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { ExibicaoCondicional } from 'view/component/ExibicaoCondicional/ExibicaoCondicional';
import { FormikDebug } from 'view/component/Formulario/FormikDebug';
import { BotaoLimpar } from 'view/component/Botao/BotoesComuns';
import { ClassificacaoCascader, ClassificacaoCascaderStyled } from 'view/component/ClassificacaoCascader/ClassificacaoCascader';

interface SolicitacoesFiltrosProps {
  restricoes: RestricoesCamposBuscaSolicitacoesFormulario;
  filtros: SolicitacoesQueryParams;
  onFiltrosAtualizados: (values : any) => void;
}

export const SolicitacoesFiltros: FC<SolicitacoesFiltrosProps> = ({filtros, onFiltrosAtualizados, restricoes}) => {
  // FIXME: Campos de texto deve ser aplicados explicitamente o filtro vazio por conta do 
  //        do enable reinitialize
  const limparFiltros = async () => await onFiltrosAtualizados({titulo: '', descricao: '', dataCriacao: '', dataCriacaoFim: ''});
  const submit = async (values: any) => await onFiltrosAtualizados(values);

  return (
    <details>
      <summary><H3>Filtros</H3></summary>
      <Formulario 
        formik={{
          initialValues: filtros,
          enableReinitialize: true,
          onSubmit: submit
        }}

        operacao={OperacaoFormularioBusca.Buscar}
        restricoes={restricoes}
      >
        <div>
          {DEVELOPMENT &&
          <>
            Pensar em fazer mais compacto: 
            <a href="https://styleguide.vtex.com/#/Components/Display/FilterBar">Exemplo compacto 1</a>
            <a href="https://atlassian.design/patterns/page-header/">{' | '} Exemplo compacto 2</a>
          </>
          }
        </div>
        <div className="row">
          <ExibicaoCondicional name="titulo">
          <div className='col-xs-6'>
            <Label htmlFor="titulo">Título</Label>
            <Input name="titulo" id="titulo" type="text" placeholder="Título da solicitação..." />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="descricao">
          <div className='col-xs-6'>
            <Label htmlFor="descricao">Descrição</Label>
            <Input name="descricao" id="descricao" type="text" placeholder="Descrição da solicitação..." />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="situacao">
          <div className='col-xs-4'>
            <Label htmlFor="situacao">Situação</Label>
            <SituacaoSelect isMulti={true as any} name="idSituacao" inputId="situacao" todas={true} />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="idSolicitante">
          <div className='col-xs-4'>
            <Label htmlFor="idSolicitante">Solicitante</Label>
            <ServidorField name="idSolicitante" inputId="idSolicitante" />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="idClassificacao">
          <div className='col-xs-4'>
            <Label htmlFor="idClassificacao">Classificação</Label>
            <ClassificacaoCascaderStyled name="idClassificacao" placeholder="Classificação..." />
          </div>
          </ExibicaoCondicional>
        
          <ExibicaoCondicional name="prioridade">
          <div className='col-xs-4'>
            <Label htmlFor="prioridade">Prioridade</Label>
            <PrioridadeSelect isMulti={true as any} name="idPrioridadeSolicitacao" inputId="prioridade" />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="idResponsavelTecnico">
          <div className='col-xs-4'>
            <Label htmlFor="idResponsavelTecnico">Responsável Técnico</Label>
            <div>
              <ResponsavelTecnicoSelect 
                name="idResponsavelTecnico"
                inputId="idResponsavelTecnico"
                isMulti={true as any}
              />
            </div>
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="idUnidadeResponsavel">
          <div className='col-xs-4'>
            <Label htmlFor="idUnidadeResponsavel">Unidade responsável</Label>
            <div>
              <UnidadeSelect
                name="idUnidadeResponsavel"
                inputId="idUnidadeResponsavel"
                isMulti={true as any} />
            </div>
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="dataCriacaoInicio">
          <div className='col-xs-4'>
            <Label htmlFor="dataCriacaoInicio">Criado a partir de</Label>
            <Input name="dataCriacaoInicio" id="dataCriacaoInicio" type="date" />
          </div>
          </ExibicaoCondicional>

          <ExibicaoCondicional name="dataCriacaoFim">
          <div className='col-xs-4'>
            <Label htmlFor="dataCriacaoFim">Criado até</Label>
            <Input name="dataCriacaoFim" id="dataCriacaoFim" type="date" />
          </div>
          </ExibicaoCondicional>

        </div>

        <footer>
          <Botao type="submit">Aplicar</Botao>
          <BotaoLimpar onClick={limparFiltros} />
        </footer>
        <FormikDebug />
      </Formulario>
    </details>
  )
}